<template>
    <div>
        <div
            class="cruise-stappen border2 stap1 width100 marginbottom15"
            v-if="waiting"
        >
            <card-header title="Vluchten" step="4" />
            <div class="stap-content">
                <loading-circle />
                <div class="clear"></div>
            </div>
        </div>
        <div
            class="cruise-stappen border2 stap1 width100 marginbottom15"
            v-else-if="getFLights"
        >
            <card-header title="Vluchten" step="4" />
            <div class="stap-content">
                <FlightsCached
                    v-if="cruiseFlights"
                    :cruiseFlights="cruiseFlights"
                    :cruiseID:="cruiseID"
                />
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import FlightsCached from '@/views/components/FlightsCached'
import CardHeader from '@/views/components/Card/CardHeader'
import LoadingCircle from '@/views/components/States/LoadingCircle'

export default {
    name: 'FlightSetup',
    components: {
        LoadingCircle,
        FlightsCached,
        CardHeader,
    },
    computed: {
        cruiseFlights: function() {
            let id = this.cruiseID

            return this.$store.state.flights.find(function(flight) {
                return flight.cruiseID === id
            })
        },
        cruiseID: function() {
            return this.$store.state.highlightedRate.cruiseID
        },
        getFLights: function() {
            return this.$store.state.findFlights
        },
        shown: function() {
            return (
                this.cruiseFlights &&
                this.cruiseFlights.results &&
                Object.keys(this.cruiseFlights.results).length > 0
            )
        },
        waiting: function() {
            return this.$store.state.flightLoading
        },
    },
}
</script>
